import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { PiSuggestionSharedGoalStateServiceProvider, PiSuggestionSharedMetricStateServiceProvider } from "@webapp/okrs/metrics/providers/metrics.provider";
import { CreateKrSuggestionDrawerLegacyComponent } from "@webapp/platform-intelligence/expandable-suggestions/suggestion-drawer/create-kr-suggestion-drawer-legacy/create-kr-suggestion-drawer-legacy.component";
import { CreateMetricSuggestionDrawerComponent } from "@webapp/platform-intelligence/expandable-suggestions/suggestion-drawer/create-metric-suggestion-drawer/create-metric-suggestion-drawer.component";
import { SuggestionDrawerEffectivenessTabComponent } from "@webapp/platform-intelligence/expandable-suggestions/suggestion-drawer/shared/components/drawer-tabs/effectiveness-tab/effectiveness-tab.component";
import { SuggestionDrawerOverviewTabComponent } from "@webapp/platform-intelligence/expandable-suggestions/suggestion-drawer/shared/components/drawer-tabs/overview-tab/overview-tab.component";
import { QuantivePlusModule } from "@webapp/platform-intelligence/quantive-plus/quantive-plus.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiGridModule } from "@webapp/ui/grid/grid.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiLabelModule } from "@webapp/ui/label/label.module";
import { UiSkeletonModule } from "@webapp/ui/skeleton/skeleton.module";
import { UiTabModule } from "@webapp/ui/tab/tab.module";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";
import { PlatformIntelligenceSharedModule } from "../../shared/pi-shared.module";
import { PIExpandableSuggestionsSharedModule } from "../shared/expandable-suggestions-shared.module";
import { CreateObjectiveSuggestionDrawerComponent } from "./create-objective-suggestion-drawer/create-objective-suggestion-drawer.component";
import { SuggestionDrawerBaseComponent } from "./shared/components/drawer-base/suggestion-drawer-base.component";
import { SuggestionDrawerBulletPointCardComponent } from "./shared/components/drawer-bullet-point-card/suggestion-drawer-bullet-point-card.component";
import { SuggestionDrawerCreateFormModalWrapperComponent } from "./shared/components/drawer-create-form-modal-wrapper/suggestion-drawer-create-form-modal-wrapper.component";
import { SuggestionDrawerParagraphComponent } from "./shared/components/drawer-paragraph/suggestion-drawer-paragraph.component";
import { SuggestionDrawerSideModalWrapperComponent } from "./shared/components/drawer-side-modal-wrapper/suggestion-drawer-side-modal-wrapper.component";
import { SuggestionDrawerSuggestionGroupCardComponent } from "./shared/components/drawer-suggestion-group-card/suggestion-drawer-suggestion-group-card.component";
import {
  SuggestionDrawerAllSuggestionDeclarations,
  SuggestionDrawerAllSuggestionExports,
} from "./shared/components/drawer-tabs/all-suggestions-tab/all-suggestions-tab.module";
import { SuggestionDrawerOverviewTabV2Component } from "./shared/components/drawer-tabs/overview-tab-v2/overview-tab-v2.component";
import { PISuggestionSharedDrawerModule } from "./shared/shared.module";
import { UpdateKrSuggestionDrawerComponent } from "./update-kr-suggestion-drawer/update-kr-suggestion-drawer.component";
import { UpdateObjectiveSuggestionDrawerComponent } from "./update-objective-suggestion-drawer/update-objective-suggestion-drawer.component";

@NgModule({
  imports: [
    CommonModule,
    UiIconModule,
    UiButtonModule,
    LocalizationModule,
    UiTooltipModule,
    UiTabModule,
    UiGridModule,
    UiSkeletonModule,
    UiLabelModule,
    PlatformIntelligenceSharedModule,
    PIExpandableSuggestionsSharedModule,
    PISuggestionSharedDrawerModule,
    QuantivePlusModule,
  ],
  declarations: [
    SuggestionDrawerBaseComponent,
    SuggestionDrawerSideModalWrapperComponent,
    SuggestionDrawerCreateFormModalWrapperComponent,
    SuggestionDrawerParagraphComponent,
    SuggestionDrawerBulletPointCardComponent,
    SuggestionDrawerSuggestionGroupCardComponent,
    SuggestionDrawerOverviewTabComponent,
    SuggestionDrawerOverviewTabV2Component,
    SuggestionDrawerEffectivenessTabComponent,
    UpdateObjectiveSuggestionDrawerComponent,
    UpdateKrSuggestionDrawerComponent,
    CreateObjectiveSuggestionDrawerComponent,
    CreateKrSuggestionDrawerLegacyComponent,
    CreateMetricSuggestionDrawerComponent,
    ...SuggestionDrawerAllSuggestionDeclarations,
  ],
  exports: [
    SuggestionDrawerBaseComponent,
    SuggestionDrawerSideModalWrapperComponent,
    SuggestionDrawerCreateFormModalWrapperComponent,
    SuggestionDrawerParagraphComponent,
    SuggestionDrawerBulletPointCardComponent,
    SuggestionDrawerSuggestionGroupCardComponent,
    SuggestionDrawerOverviewTabComponent,
    SuggestionDrawerOverviewTabV2Component,
    SuggestionDrawerEffectivenessTabComponent,
    UpdateObjectiveSuggestionDrawerComponent,
    UpdateKrSuggestionDrawerComponent,
    CreateObjectiveSuggestionDrawerComponent,
    CreateKrSuggestionDrawerLegacyComponent,
    CreateMetricSuggestionDrawerComponent,
    ...SuggestionDrawerAllSuggestionExports,
  ],
  providers: [PiSuggestionSharedGoalStateServiceProvider, PiSuggestionSharedMetricStateServiceProvider],
})
export class PISuggestionDrawerModule {}
